import { v4 as uuidv4 } from "uuid";

// Constants
const LOW_STOCK_THRESHOLD = 5;

/**
 * Get product stock status with display text
 */
export const getStockStatus = (stockLevel) => {
  if (stockLevel <= 0) {
    return {
      text: "Out of Stock",
      status: "out-of-stock",
    };
  }
  if (stockLevel <= LOW_STOCK_THRESHOLD) {
    return {
      text: `Low Stock (${stockLevel} left)`,
      status: "low-stock",
    };
  }
  return {
    text: "In Stock",
    status: "in-stock",
  };
};

/**
 * Calculate total price for cart items
 */
export const calculateCartTotal = (items) => {
  return items.reduce((total, item) => total + item.price * item.quantity, 0);
};

/**
 * Filter products based on search and category
 */
export const filterProducts = (
  products,
  { searchQuery = "", categories = [] },
) => {
  return products.filter((product) => {
    // Category filter
    if (
      categories.length > 0 &&
      !product.categories.some((c) => categories.includes(c))
    ) {
      return false;
    }

    // Search filter
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      const searchText = `
        ${product.name} 
        ${product.description} 
        ${product.tags?.join(" ") || ""}
      `.toLowerCase();

      return searchText.includes(query);
    }

    return true;
  });
};

export const generateSessionId = () => uuidv4();
export const generateCartItemId = () => uuidv4();

export const validateQuantity = (quantity, maxQuantity = 10) => {
  const parsedQuantity = parseInt(quantity);
  if (isNaN(parsedQuantity) || parsedQuantity < 1) return 1;
  if (maxQuantity && parsedQuantity > maxQuantity) return maxQuantity;
  return parsedQuantity;
};

export const mergeCartItems = (existingItems, newItems) => {
  const mergedItems = [...existingItems];

  newItems.forEach((newItem) => {
    const existingIndex = mergedItems.findIndex(
      (item) =>
        item.productId === newItem.productId &&
        item.variantId === newItem.variantId,
    );

    if (existingIndex >= 0) {
      const newQty = validateQuantity(
        mergedItems[existingIndex].quantity + newItem.quantity,
        mergedItems[existingIndex].maxQuantity,
      );
      mergedItems[existingIndex].quantity = newQty;
    } else {
      mergedItems.push({
        ...newItem,
        id: generateCartItemId(),
        quantity: validateQuantity(newItem.quantity, newItem.maxQuantity),
      });
    }
  });

  return mergedItems;
};
